import { useState } from 'react';

import { useServerPagination } from '@dutchie/backoffice-ui-library';

import { useProcessedBrandsQuery } from './use-processed-brands-query';

export const useServerPaginatedBrandData = () => {
  const [totalCount, setTotalCount] = useState(0);

  const {
    filterVariables,
    handleSearchChange,
    paginationModel,
    setPaginationModel,
    setSortModel,
    sortModel,
  } = useServerPagination(undefined, { totalCount });

  const { rows, loading } = useProcessedBrandsQuery({
    onDataReceived: setTotalCount,
    paginationModel,
    search: filterVariables.search,
  });

  return {
    filterVariables,
    handleSearchChange,
    loading,
    paginationModel,
    rows,
    setPaginationModel,
    setSortModel,
    sortModel,
    totalCount,
  };
};
